import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, Input} from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {

  @Input() backurl: string;
  @Input() enableBack:boolean;
  userName: string = '';
  plan: string = '';
  isUpgrading = false;
  constructor(private router: Router, private dataservice: CommonService,private socialAuthService: SocialAuthService) {
    this.userName = localStorage.getItem('userName');
    this.plan = localStorage.getItem('plan');
  }
  logout() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userName');
    localStorage.removeItem('plan');
    localStorage.removeItem('otpemail');
    this.router.navigate(['']);
    this.socialAuthService.signOut();
  }
  get isPricingPage(): boolean {
    return this.router.url.startsWith('/panel/pricing');
  }

  upgradeDowngrade() {
    this.isUpgrading = true;
    this.dataservice.getData('/api/upgrade-downgrade').pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          window.open(response['url'],'_self');
        },
        (error) => {
          this.isUpgrading = false;
          if (error.status === 401) {
            this.dataservice.tokenExpireLogout();
          } else {
            console.log(error); 
            let err = error.error;
            alert('Something goes wrong. Contact support');
            /* let thisvar = this;
            Object.keys(err).forEach(key => {
                thisvar._snackBar.open(err[key], '', {
                  duration: 3000,
                  horizontalPosition: thisvar.horizontalPosition,
                  verticalPosition: thisvar.verticalPosition,
                });
            }); */
          }
        });
  }
}
